import * as z from 'zod';

export const menuFormSchema = z.object({
  Name: z.string().min(1, { message: 'MENU_NAME_REQUIRED' }),
  WeekDay: z.string().min(1, { message: 'WEEKDAY_REQUIRED' }),
  MenuItems: z.array(z.string()).min(1, { message: 'AT_LEAST_ONE_MENU_ITEM_REQUIRED' }),
});

export type MenuFormValues = z.infer<typeof menuFormSchema>;
